import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {WorksurfaceService} from './worksurface.service';

@Component({
  selector: 'app-worksurface',
  imports: [],
  templateUrl: './worksurface.html',
  styleUrl: './worksurface.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Worksurface {
  protected worksurfaceService = inject(WorksurfaceService);

  protected onWorksurfaceChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    console.log(value);
    this.worksurfaceService.setSelectedWorksurface(value);
  }

  selectWorksurface(code: string) {
    this.worksurfaceService.setSelectedWorksurface(code);
  }
}
